var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { makeStyles } from "../../styles/index";
import { useMeasure } from "../../hooks/useMeasure";
import { useLink } from "../../hooks/useLink";
var styles = function (theme) { return ({
    root: {
        display: 'block',
        color: theme.palette.light.text.primary,
        backgroundColor: theme.palette.light.background.paper,
        borderRadius: 2,
        boxShadow: theme.shadows[1],
    },
    sheet: {
        borderRadius: 'inherit',
    },
    clickable: {
        cursor: 'pointer',
    },
}); };
var useStyles = makeStyles(styles, { name: 'SnCard' });
export var Card = function (props) {
    var _a;
    var href = props.href, to = props.to, component = props.component, onClick = props.onClick, isTargetBlank = props.isTargetBlank, propClassName = props.className, style = props.style, children = props.children, others = __rest(props, ["href", "to", "component", "onClick", "isTargetBlank", "className", "style", "children"]);
    var linkProps = { href: href, to: to, component: component, isTargetBlank: isTargetBlank };
    var Component = useLink(linkProps);
    var measureStyle = useMeasure(props).style;
    var classes = useStyles(props);
    var className = classNames(classes.root, (_a = {},
        _a[classes.clickable] = onClick || href || to,
        _a), propClassName);
    var handleClick = function (e) {
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    return (React.createElement(Component, __assign({ className: className, style: __assign(__assign({}, measureStyle), style), onClick: handleClick }, others), children));
};
